<template>
  <Darg
    :draggable="draggable"
    :dataSource="dragDataSource"
    @dragstart="dragstart(DragType.file)"
    :dragRef="fileRef"
    :dragImage="dragImage[currentLayout]"
  >
    <div ref="fileRef" :class="[`file-${currentLayout}`, checked ? 'is_checked' : '']">
      <div class="operation">
        <div
          :class="['my-check-box', checked ? 'check-box-checked' : 'check-box-unckeck']"
          @click="changeChecked(checked)"
        ></div>
        <a-dropdown>
          <img class="operation_img" src="../../../assets/more_operation.png" />
          <template #overlay>
            <ul class="dropdow_content">
              <EditFileModal
                :modalId="`edit_modal_${dataSource.articleKey}`"
                :name="fileTitle"
                ref="editFileNameModalRef"
                rlogKey="all_mp3_more_click_re"
                topTip="注: 音频文件名修改成功后，匹配的字幕文件名也将同时修改"
                @submit="editFileNameSubmit"
              >
                <template v-slot:editImg>
                  <img class="type-icon" :src="require('../imgs/music.png')" />
                </template>
                <li class="dropdow_item" v-if="dataSource.type == 'article'">重命名</li>
              </EditFileModal>
              <UploadIrc
                v-show="!getIsLyricShow(dataSource.type)"
                @update="getAllList"
                :checkFileList="[{ ...dataSource, key: dataSource.articleKey }]"
                :columnKey="columnKey"
              >
                <div class="dropdow_item" data-rlog="all_mp3_more_click_add">
                  {{ hasLyric(dataSource) ? '替换字幕文件' : '添加字幕文件' }}
                </div>
              </UploadIrc>
              <li v-if="getIsLyricShow(dataSource.type)" class="dropdow_item" @click="goEdit">
                编辑字幕
              </li>
              <ConfirmModal
                @confirm="handleDelete"
                confirmBtnTxt="删除"
                :rlogKey="
                  dataSource.type == 'article'
                    ? 'all_mp3_more_click_delete'
                    : 'all_lrc_more_click_delete'
                "
              >
                <li class="dropdow_item">删除</li>
              </ConfirmModal>
            </ul>
          </template>
        </a-dropdown>
      </div>
      <div class="img-content">
        <LyricPreview :dataSource="dataSource" v-if="getIsLyricShow(dataSource.type)">
          <img class="folder_img" src="../imgs/lyirc.png" />
        </LyricPreview>
        <LyricPreview :dataSource="dataSource" v-else-if="dataSource.isVideo === 0">
          <img class="folder_img" src="../imgs/music.png" />
        </LyricPreview>
        <LyricPreview :dataSource="dataSource" v-else>
          <img class="folder_img" src="../imgs/video.png" />
        </LyricPreview>
      </div>
      <LyricPreview :dataSource="dataSource">
        <div class="folder_name">{{ name ?? '认真的雪' }}</div>
      </LyricPreview>
    </div>
  </Darg>
</template>

<script setup>
import { ref, watch, onMounted, defineAsyncComponent, defineEmits, defineProps } from 'vue';
import { message } from 'ant-design-vue';
import businessService from '@/services/business';
import intervalAudio from '../../../utils/intervalAudio';
import ConfirmModal from '@/components/common/ConfirmModal.vue';
import EditFileModal from '@/components/common/EditFileModal.vue';
import UploadIrc from '@/components/Upload/UploadIrc.vue';
import checkIsOverSelectArea from '@/components/MouseSeleted/method';
import Darg from '@/components/Drag/index.vue';
import { getFileName, getIsLyricShow, getFileType } from '../../../utils/utils';
import { hasLyric } from '../methods';
import routeController from '@/controller/router';
import handleDrag, { dragImage, DragType } from './method';

const LyricPreview = defineAsyncComponent(() => import('./LyricPreview.vue'));

const props = defineProps({
  draggable: {
    type: Boolean,
    default: true,
  },
  name: {
    type: String,
    require: true,
  },
  articleKey: {
    type: String,
    require: true,
  },
  checkFolderList: {
    type: Array,
    require: false,
  },
  checkFileList: {
    type: Array,
    require: false,
  },
  checkIrcList: {
    type: Array,
    require: false,
  },
  index: Number,
  checked: {
    type: Boolean,
    require: false,
  },
  columnKey: {
    type: String,
    require: false,
    default: 'defaultColumnKey',
  },
  dataSource: {
    type: Object,
    require: true,
  },
  fileList: {
    type: Object,
    require: true,
  },
  currentLayout: {
    type: String || Array,
    default: 'grid',
  },
});
const emit = defineEmits([
  'initChoose',
  'checkedFileList',
  'update',
  'getAllList',
  'updatefilePlayStatus',
]);
const { dragstart, dragDataSource } = handleDrag(props, emit);
const fileRef = ref(null);
const eiditVisible = ref(false);
const fileList = ref(props.fileList);
const editFileNameModalRef = ref(null);
const fileTitle = ref('');
watch(
  () => props.name,
  newValue => {
    fileTitle.value = getFileName(newValue);
  },
  {
    immediate: true,
  }
);
watch(
  () => props.fileList,
  newValue => {
    fileList.value = newValue;
  },
  {
    immediate: true,
  }
);
const { changePage } = routeController();
function goEdit() {
  const { articleKey, columnKey, audioLang } = props.dataSource;
  changePage('/hearingDetail', {
    articleKey,
    columnKey,
    langType: audioLang,
  });
}
const switchAudio = record => {
  const index = fileList.value.findIndex(item => item.articleKey === record.articleKey);
  let data = [].concat(fileList.value);
  if (index === -1) {
    return;
  }
  // 暂停
  if (data[index].playing) {
    intervalAudio.pauseIntervalAudio();
    intervalAudio.destroyIntervalAudio();
    data[index].playing = false;
    emit('updatefilePlayStatus', data);
    return;
  }
  // 播放当前音频，并停止其他音频
  data = data.map(item => {
    const itemData = { ...item };
    itemData.playing = false;
    return itemData;
  });
  data[index].playing = true;
  emit('updatefilePlayStatus', data);
  intervalAudio.destroyIntervalAudio();
  intervalAudio.initIntervalAudio({
    audios: [JSON.parse(fileList.value[index].audioInfo).url],
    readInterval: 100, // xx秒
    readTimes: 1,
    loaded: () => {},
    end: () => {
      data[index].playing = false;
      emit('updatefilePlayStatus', data);
    },
  });
  intervalAudio.playIntervalAudio();
};
const changeChecked = (checked, isSet) => {
  const { title, articleKey, type, lrcStatus } = props.dataSource;
  emit(
    'checkedFileList',
    {
      title,
      key: articleKey,
      id: articleKey,
      articleKey,
      lrcStatus,
      type,
    },
    isSet ? checked : !checked
  );
};
onMounted(() => {
  checkIsOverSelectArea(
    fileRef.value,
    isSelected => {
      if (props.checked !== isSelected) {
        changeChecked(isSelected, true);
      }
    },
    () => {
      // 点击空白区域取消选中
      changeChecked(false, true);
    },
    'file'
  );
});

const handleDelete = toggleModal => {
  function callback(res) {
    if (res.code === 0) {
      toggleModal(false);
      emit('update', 'file', 'delete', props.dataSource.articleKey);
    } else {
      message.error({ content: res.msg });
    }
  }
  const { dataSource, columnKey } = props;
  if (getIsLyricShow(dataSource.type)) {
    businessService
      .deleteLrc({
        articleKey: dataSource.articleKey,
        columnKey,
      })
      .then(res => {
        callback(res);
      })
      .catch(e => {
        message.error({ content: e });
      });
    return;
  }
  businessService
    .articleUpdateStatus({
      articleKey: props.dataSource.articleKey,
      status: 2,
    })
    .then(res => {
      callback(res);
    })
    .catch(e => {
      message.error({ content: e });
    });
};
function editFileNameSubmit(value, callback) {
  const { dataSource } = props;
  const hideLoading = message.loading({ content: 'loading', duration: 0 });
  //    // 修改单曲名称
  businessService
    .articleUpdate({
      columnKey: dataSource.columnKey,
      articleKey: dataSource.articleKey,
      title: `${value}.${getFileType(dataSource.title)}`,
      audioDuration: dataSource.audioDuration,
      audioSize: dataSource.audioSize,
      audioUrl: dataSource.audioUrl,
    })
    .then(res => {
      hideLoading();
      if (res.code === 0) {
        emit('update', 'file');
      } else {
        message.error({ content: res.msg || '请求失败，请重试' });
      }
      callback(false);
    })
    .catch(e => {
      hideLoading();
      message.error({ content: e });
    });
}
// 修改单曲名称
const updateFilename = () => {
  emit('update', 'file');
};
// 确认删除文件
const handleEditOk = () => {
  eiditVisible.value = false;
  updateFilename();
};
function getAllList() {
  emit('getAllList');
}
</script>

<style lang="scss" scoped>
.file-grid {
  width: 160px;
  height: 160px;
  cursor: pointer;
  position: relative;
  padding-top: 20px;
  box-sizing: border-box;
  text-align: center;
  &:hover {
    background: $grey4;
    border-radius: 8px;
    position: relative;
    .operation {
      visibility: visible;
    }
  }
  .folder_img {
    width: 80px;
    user-select: none;
    -webkit-user-drag: none;
  }
  .folder_name {
    padding: 0 10px;
    margin-top: 10px;
    font-weight: 500;
    line-height: 16px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    word-wrap: break-word;
    word-break: break-all;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .operation {
    visibility: hidden;
    padding: 10px 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    height: 32px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    .operation_img {
      width: 20px;
    }
  }
}
.is_checked {
  background: $grey4;
  border-radius: 8px;
  .operation {
    visibility: visible;
  }
}
.play-content {
  visibility: hidden;
}
.img-content {
  width: 80px;
  height: 80px;
  margin: 0 auto;
}
.img-content:hover {
  .play-content {
    z-index: 1;
    visibility: visible;
    width: 50px;
    height: 50px;
    top: 14px;
    position: absolute;
    left: 50%;
    margin-left: -25px;
  }
  .pause-icon {
    width: 100%;
    height: 100%;
    background: url('../imgs/pause.png') no-repeat center center;
    background-size: 100% 100%;
  }
  .playing-icon {
    width: 100%;
    height: 100%;
    background: url('../imgs/playing.png') no-repeat center center;
    background-size: 100% 100%;
  }
}
.dropdow_content {
  background: rgba(0, 0, 0, 0.8);
  width: 140px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  .dropdow_item {
    cursor: pointer;
    padding-left: 20px;
    color: #fff;
    font-size: 15px;
    line-height: 50px;
    height: 50px;
    width: 140px;
  }
}
</style>
